<odx-modal-header>
  <odx-area-header i18n="@@group.modal.discardGroup.header">Gruppe verwerfen?</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <p i18n="@@group.modal.discardGroup.text">
    Es muss mindestens ein Produkt hinzugefügt werden, damit die Gruppe gespeichert werden kann. Soll die Gruppe verworfen werden?
  </p>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" odxModalDismiss i18n="@@global.dismiss">Abbrechen</button>
  <button odxButton variant="primary" i18n="@@group.modal.button.confirm" (click)="onConfirm()">Bestätigen</button>
</odx-modal-footer>
